































































































import Vue from 'vue'
import { FindDriver, Create } from '@/api/device'
import { Device, Driver } from '@/../ui/types/device'

declare interface OptionDriver {
  value: string
  text: string
}
export default Vue.extend({
  data() {
    return {
      optionDriver: [] as OptionDriver[],
      selectedDriver: '',
      listDriver: [] as Driver[],
      usedDriver: {} as Driver | undefined,

      name: '',
      description: '',
      enabled: false,
    }
  },
  methods: {
    async findDriver() {
      this.listDriver = await FindDriver()
      const options = []
      for (let i = 0; i < this.listDriver.length; i++) {
        const driver = this.listDriver[i]

        const option = { value: driver.name, text: driver.title }
        options.push(option)
      }

      this.optionDriver = options
    },

    onDriverChange() {
      this.generateFieldsConfig(this.selectedDriver)
    },
    async generateFieldsConfig(driver: string) {
      this.usedDriver = this.listDriver.find((element) => {
        return element.name === driver
      })
    },

    async save() {
      const configDevice = this.usedDriver?.default
      const device: Device = {
        id: 0,
        config: configDevice,
        name: this.name,
        description: this.description,
        driver: this.selectedDriver,
        enabled: this.enabled,
        isGroup: false,
        groupId: null,
      }
      let message = ''
      try {
        await Create(device)
        message = 'device added successfully'
        this.$toast.success(message)

        this.$router.push('/cems/setting/device')
      } catch (error) {
        console.log(error)
      }
    },
  },
  created() {
    this.findDriver()
  },
})
